<template>
  <div v-if="solutionCount > 0" class="solution-replay-container">
    <ion-button v-if="!isVisible" @click="isVisible = true" fill="clear" class="show-button">
      <ion-icon :icon="playCircleOutline" slot="icon-only"></ion-icon>
    </ion-button>

    <ion-card v-if="isVisible">
      <ion-card-header>
        <ion-card-title>Solution Replay</ion-card-title>
        <ion-button @click="isVisible = false" fill="clear" class="close-button">
          <ion-icon :icon="closeOutline" slot="icon-only"></ion-icon>
        </ion-button>
      </ion-card-header>
      <ion-card-content>
        <div class="controls">
          <ion-select
            label="Solution"
            label-placement="stacked"
            v-model="selectedSolution"
            @ionChange="onSolutionSelected"
            interface="popover"
          >
            <ion-select-option v-for="i in solutionCount" :key="i" :value="i - 1">
              Solution {{ i }}
            </ion-select-option>
          </ion-select>
          <ion-button @click="playNextStep" :disabled="!isPlayerTurn" expand="block">
            Next Step
          </ion-button>
        </div>
      </ion-card-content>
    </ion-card>
  </div>
</template>

<script setup>
import { inject, ref, computed, watch } from 'vue';
import {
  IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonButton, IonSelect, IonSelectOption, IonIcon,
} from '@ionic/vue';
import { playCircleOutline, closeOutline } from 'ionicons/icons';
import { GameEvents } from '../../../lib/GameEvents';

const game = inject('game');
const selectedSolution = ref(null);
const isVisible = ref(false);

// Read from solutionReplay slice — all state managed by SolutionReplayMode
const solutionCount = computed(() => game.state.solutionReplay?.solutionCount || 0);
const isPlayerTurn = computed(() => game.state.solutionReplay?.isPlayerTurn || false);

// When solutionCount changes (new level loaded), reset selection
watch(solutionCount, (count) => {
  selectedSolution.value = count > 0 ? 0 : null;
});

const onSolutionSelected = () => {
  game.emit(GameEvents.SELECT_SOLUTION, selectedSolution.value);
};

const playNextStep = () => game.emit(GameEvents.PLAY_NEXT_SOLUTION_STEP);
</script>

<style scoped>
.solution-replay-container {
  position: fixed;
  bottom: 80px; /* Adjust to be above action bar */
  left: 10px;
  z-index: 1000;
  width: 250px;
}
.show-button {
  font-size: 32px;
  color: var(--ion-color-tertiary);
  --padding-start: 0;
  --padding-end: 0;
}
ion-card {
  --background: rgba(51, 51, 51, 0.9);
  --color: #fff;
}
ion-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
ion-card-title {
  font-size: 1em;
}
.controls {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.controls ion-button {
  --background: var(--ion-color-tertiary);
}
</style>
